import emptyFunction from 'react-utils/emptyFunction';
import { useCallback, useMemo, useReducer } from 'react';
import { AsyncDisqualifiedLeadFollowUpModal } from '../../../leads/modals/AsyncDisqualifiedLeadFollowUpModal';
import { AsyncCreateDealFromLeadModal } from '../../../leads/modals/AsyncCreateDealFromLeadModal';
import { jsx as _jsx } from "react/jsx-runtime";
const modalReducer = (state, action) => {
  switch (action.type) {
    case 'OPEN_MODAL':
      return {
        modalOpen: action.modal,
        onConfirm: action.onConfirm,
        onCancel: action.onCancel,
        extraProperties: action.extraProperties
      };
    case 'CLOSE_MODAL':
      return {
        modalOpen: null,
        onConfirm: emptyFunction,
        onCancel: emptyFunction
      };
    default:
      return state;
  }
};
const initialState = {
  modalOpen: null,
  onConfirm: emptyFunction,
  onCancel: emptyFunction,
  extraProperties: {}
};
export const useLeadStageModal = () => {
  const [modalState, dispatch] = useReducer(modalReducer, initialState);
  const openModal = useCallback(modalData => {
    dispatch(Object.assign({
      type: 'OPEN_MODAL'
    }, modalData));
  }, [dispatch]);
  const closeModal = useCallback(() => {
    dispatch({
      type: 'CLOSE_MODAL'
    });
  }, [dispatch]);
  const stageValidationModal = useMemo(() => {
    switch (modalState.modalOpen) {
      case 'DEAL_CREATE':
        {
          return /*#__PURE__*/_jsx(AsyncCreateDealFromLeadModal, {
            onConfirm: modalState.onConfirm,
            onCancel: modalState.onCancel,
            extraProperties: modalState.extraProperties
          });
        }
      case 'RE_ATTEMPTING_LEAD_AND_TASK_REQUIRED':
      case 'FOLLOW_UP_TASK_REQUIRED':
      case 'RE_ATTEMPTING_LEAD_REQUIRED':
        {
          var _modalState$extraProp, _modalState$extraProp2;
          return /*#__PURE__*/_jsx(AsyncDisqualifiedLeadFollowUpModal, {
            modalType: modalState.modalOpen,
            onConfirm: modalState.onConfirm,
            onCancel: modalState.onCancel,
            disqualificationReason: ((_modalState$extraProp = modalState.extraProperties) === null || _modalState$extraProp === void 0 ? void 0 : _modalState$extraProp.disqualificationReason) || '',
            disqualificationNote: ((_modalState$extraProp2 = modalState.extraProperties) === null || _modalState$extraProp2 === void 0 ? void 0 : _modalState$extraProp2.disqualificationNote) || ''
          });
        }
      default:
        {
          return null;
        }
    }
  }, [modalState]);
  return useMemo(() => ({
    openModal,
    closeModal,
    stageValidationModal
  }), [openModal, closeModal, stageValidationModal]);
};